<template>
  <div id="device-bg-main">
    <v-container>
      <div class="login-form">
        <v-col
          lg="5"
          md="10"
          sm="10"
        >
          <div class="text-center mt-5">
            <div class="logo-style">
              <img
                width="150px"
                src="../../../assets/img/swift-checkin-ezybuild-logo.png"
                alt
              >
            </div>
            <v-card
              width="100%"
              color="#FFFFFF"
              elevation="0"
            >
              <v-card-title>
                <h3>Kiosk Login</h3>
              </v-card-title>
              <v-card-text>
                <v-form
                  ref="form"
                  v-model="valid"
                >
                  <v-text-field
                    v-model="name"
                    label="Kiosk Name*"
                    dense
                    :rules="[(v) => !!v || 'This field is required']"
                    filled
                    color="#000000"
                    light
                    outlined
                  />
                  <v-text-field
                    v-model="password"
                    label="kiosk Password*"
                    :type="showPassword ? 'text' : 'password'"
                    :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                    dense
                    :rules="[(v) => !!v || 'This field is required']"
                    filled
                    color="#000000"
                    light
                    outlined
                  />
                  <div class="text-left">
                    <v-checkbox
                      v-model="showPassword"
                      color="#0000"
                      label="Show Password"
                      value="primary"
                    />
                  </div>
                  <br>
                  <v-btn
                    width="100%"
                    height="50px"
                    elevation="0"
                    @click="deviceLogin()"
                  >
                    LogIn
                  </v-btn>
                </v-form>
                <br>
                <br>
                <p class="router-style">
                  Back to start page
                  <router-link
                    to="/get-started"
                    class="router-style"
                  >
                    Go Back
                  </router-link>
                </p>
              </v-card-text>
            </v-card>
          </div>
        </v-col>
      </div>
    </v-container>
    <centre-spinner :loading="loading" />
  </div>
</template>

<script>
import spinner from '../../components/SpinnerCentre.vue';
import Constants from 'src/constants';
import axios from '@/app-axios';
export default {
  name: 'LoginPage',
  components: {
    'centre-spinner': spinner,
  },
  data () {
    return {
      loading: false,
      name: '',
      password: '',
      showPassword: false,
      valid: false,
    };
  },
  mounted () {
    this.checkDeviceUserExist();
  },
  methods: {
    deviceLogin () {
      if (this.$refs.form.validate() === false) {
        this.$store.dispatch('alert/onAlert', {
          message: 'Please fill the required fields before proceeding',
          type: Constants.ALERT_TYPE_ERROR,
        }, { root: true });
        return;
      }
      this.loading = true;
      axios.get('sanctum/csrf-cookie').then(() => {
        this.$store.dispatch('deviceLogin', {
          name: this.name,
          password: this.password,
        })
          .then(() => {
            this.$store.dispatch('alert/onAlert', {
              message: 'Welcome back! You have successfully logged in.',
              type: Constants.ALERT_TYPE_SUCCESS,
            });
            this.$router.push({ name: 'DeviceCheckInCheckOut' });
          }).catch(error => {
            this.$store.dispatch('alert/onAlert', {
              message: error.response.data.message,
              type: Constants.ALERT_TYPE_ERROR,
            }, { root: true });
            this.loading = false;
          });
      });
    },
    checkDeviceUserExist () {
      const deviceLoggin = localStorage.getItem('device');
      if (deviceLoggin) {
        this.$router.push({ name: 'DeviceCheckInCheckOut' });
      }
    },
  },
};
</script>

<style scoped>
.login-form {
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

.router-style {
  color: black;
}

.theme--dark >>> .v-label {
  color: #101010;
}
.checkin .mdi-checkbox-marked::before{
  color: #37474F !important;
  caret-color: #37474F !important;
}
::v-deep .v-input--selection-controls__input .v-icon {
  color: #37474F !important;
}
</style>
